import classNames from 'classnames';
import React from 'react';
import './HighlightMatch.less';
import { stringHighlightUtil } from './utils/stringHighlightUtils';

interface IHighlightMatchProps extends React.HTMLProps<{}> {
  children: string;
  searchString?: string;
}

/**
 * Component which highlights marked
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function HighlightMatch({ children, searchString, className }: IHighlightMatchProps) {
  let matches = stringHighlightUtil(children, searchString);
  return matches.length ? (
    <>
      {matches.map((entry, i) => {
        return entry.isMatch ? (
          <mark key={i} className={classNames("dpc-highlight-match", className)}>
            {entry.value}
          </mark>
        ) : (
          entry.value
        );
      })}
    </>
  ) : (
    <>{children}</>
  );
}
